export default __webpack_public_path__ + "static/media/person-white.e4aaac05.svg";